//@ts-nocheck

import 'core-js/es/reflect';
import 'core-js/features/reflect';
import 'core-js/stable/reflect';
import { useEffect } from 'react';
import 'zone.js';

import { Piral } from 'piral';
import React, { useState } from 'react';
import { render } from 'react-dom';

import { get, isEmpty } from 'lodash';
import { Loading } from './components/UI/loading';
import { NON_PROFILE_APPS, PILET_NAMES } from './configs/config';
import useLogin from './hooks/useLogin';
import './index.css';
import { FlowApiInitial } from './navigation/routing';
import './output.css';
import { initializeContainer, instance } from './Utils/configuration';
import { EVENTS, STORAGE_KEYS } from './Utils/constants';
import { clearStorage, getItem, setItem } from './Utils/Storage';
import { arrayIncludes, parseQueryParams, redirectTo } from './Utils/utils';
import { gamification } from './api/event';

const baseFlow = ['profile', 'payment'];

const App = () => {
  const [data, setData] = useState({
    flow: code ? baseFlow : []
  });

  const {
    signInCodeState,
    profileInfo,
    getProfileInformation,
    queryParams,
    isLoading
  } = useLogin({
    setAuthData: initializeContainer.setAuthData
  });

  const { code, appName, callbackurl } = queryParams;
  if (appName) {
    setItem(STORAGE_KEYS.APP_NAME, appName);
  }
  if (callbackurl) {
    setItem(STORAGE_KEYS.CALL_BACK_URL, callbackurl);
  }

  const authConfig = localStorage.getItem(STORAGE_KEYS.AUTH_CONFIG);
  useEffect(() => {
    const parsedInfo = parseQueryParams(get(window, 'location.search', {}));
    // set domain in local storage
    setItem(STORAGE_KEYS.CUSTOM_DOMAIN, process.env.CUSTOM_DOMAIN);
    const appName = window.location.pathname?.replace('/', '');

    if (
      parsedInfo.code &&
      parsedInfo.invoiceid &&
      appName === PILET_NAMES.NINJAPAY
    ) {
      // ninjapay collect request check code (user code) & invoice ID in query param
      setItem(STORAGE_KEYS.APP_NAME, appName);
      redirectTo(`/ninjapay${window.location.search}`);
    } else if (
      parsedInfo.code &&
      parsedInfo.phonenumber &&
      appName === PILET_NAMES.REGISTRATION
    ) {
      // Registration request check code (user code) & Phone number in query param
      setItem(STORAGE_KEYS.APP_NAME, appName);
      redirectTo(`/registration${window.location.search}`);
    } else if (!isEmpty(parsedInfo) && appName === PILET_NAMES.EKYC) {
      // ekyc request check code (user code) & callback url in query param
      clearStorage();
      setItem(STORAGE_KEYS.APP_NAME, appName);
      setItem(STORAGE_KEYS.CUSTOM_DOMAIN, process.env.CUSTOM_DOMAIN);
      setItem(STORAGE_KEYS.URL_PARAM, parsedInfo);
      if (parsedInfo?.code && parsedInfo?.callbackurl) {
        redirectTo(`/kyc-select${window.location.search}`);
      } else if (parsedInfo?.phonenumber && parsedInfo?.callbackurl) {
        redirectTo('/login');
      }
    } else if (!parsedInfo.code && isEmpty(getItem(STORAGE_KEYS.AUTH_CONFIG))) {
      if (!isEmpty(appName) && appName !== 'login') {
        setItem(STORAGE_KEYS.APP_NAME, appName);
      }
      if (isEmpty(appName)) {
        redirectTo(`/login?phonenumber=${parsedInfo?.phonenumber}`);
      }
    } else if (isEmpty(parsedInfo)) {
      history.pushState('', '', parsedInfo.appName);
      var popStateEvent = new PopStateEvent('popstate', {});
      dispatchEvent(popStateEvent);
    }

    // event tracking
    gamification({
      name: EVENTS.APP_LOAD,
      type: EVENTS.APP_LOAD,
      description: 'loading app'
    });
  }, []);

  useEffect(() => {
    FlowApiInitial(data.flow);
  }, [data]);

  useEffect(() => {
    if (signInCodeState.isFailed && isEmpty(authConfig)) {
      setData({
        ...data,
        flow: ['login', ...baseFlow]
      });
      initializeContainer.routing.goto('login');
    }
  }, [signInCodeState]);

  useEffect(() => {
    if (profileInfo.isSuccess && profileInfo.data.profileFilled) {
      window.location.replace(`/${getItem(STORAGE_KEYS.APP_NAME)}`);
    }
  }, [profileInfo.isSuccess]);

  useEffect(() => {
    if (
      (profileInfo.isFailed ||
        (profileInfo.isSuccess && !profileInfo.data.profileFilled)) &&
      window.location.pathname === '/'
    ) {
      setData({
        ...data,
        flow: baseFlow // [ "profile", "pay"];
      });
      const appName = getItem(STORAGE_KEYS.APP_NAME);
      if (appName && appName.includes('toolId')) {
        initializeContainer.routing.goto(
          'toolId/' + appName.replace('toolId', '')
        );
      } else if (appName && arrayIncludes(NON_PROFILE_APPS, appName)) {
        initializeContainer.routing.goto(appName);
      } else {
        initializeContainer.routing.goto(
          appName
            ? `profile/${appName}?navigate=Profile`
            : 'profile?navigate=Profile'
        );
      }
      // initializeContainer.routing.goto(appName);
    }
  }, [profileInfo.isFailed, profileInfo.isSuccess]);

  useEffect(() => {
    if (
      !isEmpty(authConfig) &&
      !profileInfo.isSuccess &&
      !profileInfo.isFailed &&
      code
    ) {
      const parsedAuthInfo = getItem(STORAGE_KEYS.AUTH_CONFIG);
      const userId = get(parsedAuthInfo, 'userId', '');
      let realmId = '';
      if (parsedAuthInfo.realms) {
        realmId = get(parsedAuthInfo, 'realms[0].realmIdentifier', '');
      } else {
        realmId = get(parsedAuthInfo, 'realmId', '');
      }
      getProfileInformation(userId, realmId);
    }
  }, [authConfig]);

  if (window.localStorage.state) {
    const state = JSON.parse(window.localStorage.state);
    initializeContainer.update(state);
  }
  return (
    <>
      {isLoading && <Loading />}
      <Piral instance={instance} />
    </>
  );
};

render(<App />, document.querySelector('#app'));
